

























































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class App extends Vue {
  menuItems = [
    {
      path: '/',
      title: 'Map',
      icon: 'mdi-map-marker',
    },
    {
      path: '/vote',
      title: 'Vote',
      icon: 'mdi-crane',
    },
  ];

  sidebar = false;
}
